// La rayita de progreso de la importación masiva en Mis productos
// (ADR-2026-09-30-el-detalle-de-la-importacion-vive-en-el-boton): 3 px con el color de marca,
// flotando justo debajo de la barra de búsqueda. Va en posición absoluta, así que no empuja la
// grilla. El detalle (conteo, cortar, repetidos) vive en el botón de refresh.

import React from "react";
import { lineasDeProgreso, type VistaImportacion } from "../lib/importaciones";

export const BarraDeImportacion: React.FC<{ activa: VistaImportacion | null }> = ({
  activa,
}) => {
  if (!activa) return null;
  const { principal } = lineasDeProgreso(activa);
  return (
    <div className="pointer-events-none absolute inset-x-0 top-full pt-1.5">
      <div
        className="h-[3px] w-full overflow-hidden rounded-full bg-black/[0.06]"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={
          principal.avance === null ? undefined : Math.round(principal.avance * 100)
        }
        aria-label={principal.texto}
      >
        {principal.avance === null ? (
          // Todavía no se sabe el total: un tramo que barre de lado a lado.
          <div className="importacion-barrido h-full w-1/4 rounded-full bg-brand-primary" />
        ) : (
          <div
            className="h-full rounded-full bg-brand-primary transition-[width] duration-700 ease-out"
            style={{ width: `${Math.max(2, Math.min(100, principal.avance * 100))}%` }}
          />
        )}
      </div>
    </div>
  );
};

export default BarraDeImportacion;
